export const gameList = {
  games: [
    {
      gameId: '416d56227b',
      gameTitle: 'Christmas game',
      currentPlayer: 3,
      totalGame: 10,
      gameType: 'quiz',
    },
    {
      gameId: 'abcd23rrs',
      gameTitle: 'Movies of 2025',
      currentPlayer: 43,
      totalQuestion: 15,
      gameType: 'quiz',
    },
    {
      gameId: 'abcd234sw',
      gameTitle: 'Movie of the year',
      currentPlayer: 13,
      totalQuestion: 18,
      gameType: 'geoplay',
    },
    {
      gameId: 'abcd234sj',
      gameTitle: 'Banking season',
      currentPlayer: 12,
      totalQuestion: 20,
      gameType: 'geoplay',
    },
    {
      gameId: 'abcd23rrws',
      gameTitle: 'Movies of 2025',
      currentPlayer: 30,
      totalQuestion: 15,
      gameType: 'quiz',
    },
    {
      gameId: 'abcd234fs1',
      gameTitle: 'Movie of the year 2024',
      currentPlayer: 13,
      totalQuestion: 18,
      gameType: 'geoplay',
    },
    {
      gameId: 'abcd2j34s',
      gameTitle: 'Banking season 2',
      currentPlayer: 45,
      totalQuestion: 20,
      gameType: 'quiz',
    },

    {
      gameId: '7178ea6274',
      gameTitle: 'Banking season',
      currentPlayer: 45,
      totalQuestion: 20,
      gameType: 'geoplay',
    },
    {
      gameId: '4e9f1d5bc7',
      gameTitle: 'Movies of 2025',
      currentPlayer: 45,
      totalQuestion: 15,
      gameType: 'geoplay',
    },
    {
      gameId: 'abcd234fsy',
      gameTitle: 'Movie of the year 2024',
      currentPlayer: 45,
      totalQuestion: 18,
      gameType: 'quiz',
    },
    {
      gameId: 'abcd2j34st',
      gameTitle: 'Banking season 2',
      currentPlayer: 12,
      totalQuestion: 20,
      gameType: 'geoplay',
    },
  ],
};

export const threeDotMenuConfig = [
  { module: 'menuViewPlayers', menuName: 'View Players' },
  { module: 'menuClose', menuName: 'Close Game' },
];
export const BusinessCategories = [
  { categoryId: '1', categoryName: 'Business' },
  { categoryId: '2', categoryName: 'Entertainment' },
  { categoryId: '3', categoryName: 'Science' },
  { categoryId: '4', categoryName: 'Technology' },
  { categoryId: '5', categoryName: 'Health' },
  { categoryId: '6', categoryName: 'Sports' },
  { categoryId: '7', categoryName: 'Politics' },
  { categoryId: '8', categoryName: 'History' },
  { categoryId: '9', categoryName: 'Geography' },
  { categoryId: '10', categoryName: 'Art' },
  { categoryId: '11', categoryName: 'Culture' },
  { categoryId: '12', categoryName: 'Food' },
  { categoryId: '13', categoryName: 'Travel' },
  { categoryId: '14', categoryName: 'Education' },
  { categoryId: '15', categoryName: 'Lifestyle' },
].sort((a, b) => a.categoryName.localeCompare(b.categoryName));

export const mockGeoResult: GeoResult = {
  targetLocation: {
    cityName: 'Paris',
    latitude: 48.8566,
    longitude: 2.3522,
    locationId: 'loc-001',
  },
  pinnedGeoLocations: [
    {
      distance: 245.3,
      scorePoint: 4500,
      playerId: 'player-1',
      guessedLocation: { latitude: 48.85, longitude: 2.35 },
      timeTaken: 12,
      roundTrip: 1,
      attempted: true,
      playerName: 'Alice',
    },
    {
      distance: 1023.7,
      scorePoint: 3200,
      playerId: 'player-2',
      guessedLocation: { latitude: 49.01, longitude: 2.55 },
      timeTaken: 18,
      roundTrip: 1,
      attempted: true,
      playerName: 'Bob',
    },
  ],
  currentRound: 1,
  totalRound: 5,
  currentExpiryTime: '2026-06-21T20:05:00.000Z',
};

export const mockTopPlayerSummary: TopPlayerSummary = {
  targetLocations: [
    { cityName: 'London', latitude: 51.5074, longitude: -0.1278, locationId: 'loc-001' },
    { cityName: 'Paris', latitude: 48.8566, longitude: 2.3522, locationId: 'loc-002' },
    { cityName: 'Tokyo', latitude: 35.6762, longitude: 139.6503, locationId: 'loc-003' },
  ],
  top3Players: {
    1: [
      { playerId: 'p1', distance: 12.5, playerName: 'Alice', playerIcon: '🦊', scorePoints: 950, roundTrip: 1 },
      { playerId: 'p2', distance: 25.3, playerName: 'Bob', playerIcon: '🐻', scorePoints: 870, roundTrip: 1 },
      { playerId: 'p3', distance: 40.1, playerName: 'Charlie', playerIcon: '🐯', scorePoints: 780, roundTrip: 1 },
    ],
    2: [
      { playerId: 'p1', distance: 8.2, playerName: 'Alice', playerIcon: '🦊', scorePoints: 980, roundTrip: 2 },
      { playerId: 'p4', distance: 18.7, playerName: 'Diana', playerIcon: '🐼', scorePoints: 900, roundTrip: 2 },
      { playerId: 'p2', distance: 33.0, playerName: 'Bob', playerIcon: '🐻', scorePoints: 820, roundTrip: 2 },
    ],
  },
};
